import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';

import {GetAvCompetitor} from '@graphql/avCompetitor/query';
import {createForm, renderModalError} from '@utils/forms';
import {convertToInt, isUrlParamValid} from '@utils/helpers';
import {showModal} from '@utils/modal';
import {routes} from '@constants/routes';
import HeaderRenderer from '@appComponents/HeaderRenderer';
import {TitleFromQuery} from '@appComponents/TitleFromQuery';
import {RenderBackToListButton} from '@appComponents/ButtonCollection';

import CompetitorForm from '../forms/CompetitorForm';
import CompetitorModel from '../forms/CompetitorModel';

const CompetitorEdit = ({
    match: {
        params: {
            id = null,
        },
    },
}) => {
    if (!isUrlParamValid(id)) {
        showModal({
            isVisible: true,
            content: renderModalError('Competitor', routes.competitors.index.path),
        });
    }

    const Form = React.useMemo(
        () => (createForm(CompetitorModel, CompetitorForm, {id: convertToInt(id)})),
        []
    );

    return (
        <div>
            <HeaderRenderer
                buttons={RenderBackToListButton}
                buttonsProps={{name: 'competitors.index'}}
                messagesBoxNames='competitorMessageError'
                pageTitle={
                    <TitleFromQuery
                        query={GetAvCompetitor}
                        variables={{id}}
                        errorBackLink={routes.competitors.index.path}
                        path={'competitor.name'}
                        entity={'competitor'}
                    />
                }
            />
            <Form/>
        </div>
    );
};

CompetitorEdit.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            id: PropTypes.string,
        }),
    }),
};

export default withRouter(CompetitorEdit);
